<template>
    <div v-bind:class="classObj" />
</template>

<script>
    export default {
        props: {
            large: { type: Boolean, required: false, default: false },
            invert: { type: Boolean, required: false, default: false }
        },
        computed: {
            classObj() {
                return {
                    "pc-product-logo": true,
                    "pc-product-logo-sm": !this.large,
                    "pc-product-logo-lg": this.large,
                    "pc-primary": !this.invert,
                    "bg-white": this.invert
                };
            }
        }
    };
</script>

<style lang="scss">
    .pc-product-logo-sm {
        width: 120px;
        height: 28px;
    }
    .pc-product-logo-lg {
        width: 200px;
        height: 46.7px;
    }
    .pc-product-logo {
        mask-image: url("./powerclerk-logo-white.svg");
        mask-size: 100% 100%;
    }
    .pc-primary {
        background-color: #5c73b8;
    }
</style>
